import {ProjectData} from '../content/projectdata'

export const manageCurrent = (state={}, action) => {
  switch (action.type) {
    case 'SET_CURRENT':
      return ProjectData.filter(proj => proj.path === action.payload )[0];
    case 'REMOVE_CURRENT':
      if (state.path === action.payload) {
        return {}
      }
      return state;
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/manageCurrent.js